import { createSSRApp } from 'vue';
import { registerDOMPurify } from '#utils/dompurify';
import ApplyBuyPage from './ApplyBuyPage.vue';

export default function createApp(props) {
  const app = createSSRApp(ApplyBuyPage, props);

  registerDOMPurify(app);

  return { app };
}
